import moment from 'moment';
import { SORT_ORDER, REQUEST_DATE, DATE_FORMAT } from './../constants'

export const getUserAction = method => {
  let action;

  if (method === 'get') {
    action = 'fetching';
  }

  if (method === 'post' || method === 'put') {
    action = 'saving';
  }

  if (method === 'delete') {
    action = 'deleting';
  }

  return action;
};

export const upperCaseFirst = (string) => string.charAt(0).toUpperCase() + string.slice(1);

export const isSortDesc = sortOrder => sortOrder == SORT_ORDER.DESC;

export const getDatesFromRangeString  = string => {
  let dateFrom = moment();
  let dateTo = moment();

  switch (string) {
    case REQUEST_DATE.TODAY:
      dateFrom = moment();
      break;
    case REQUEST_DATE.YESTERDAY:
      dateFrom = moment().subtract(1, 'days');
      break;
    case REQUEST_DATE.THIS_WEEK:
      dateFrom = moment().startOf('week');
      break;
    case REQUEST_DATE.LAST_WEEK:
      dateFrom = moment().startOf('week').subtract(7, 'days');
      dateTo = moment().startOf('week').subtract(1, 'days');
      break;
    case REQUEST_DATE.LAST_7_DAYS:
      dateFrom = moment().subtract(7, 'days');
      break;
    case REQUEST_DATE.THIS_MONTH:
      dateFrom = moment().startOf('month');
      break;
    case REQUEST_DATE.LAST_MONTH:
      dateFrom = moment().startOf('month').subtract(1, 'month');
      dateTo = moment().startOf('month').subtract(1, 'day');
      break;
    case REQUEST_DATE.LAST_30_DAYS:
      dateFrom = moment().subtract(30, 'days')
      break;
    case REQUEST_DATE.THIS_QUARTER:
      dateFrom = moment().startOf('quarter');
      break;
    case REQUEST_DATE.LAST_QUARTER:
      dateFrom = moment().startOf('quarter').subtract(1, 'quarter');
      dateTo = moment().startOf('quarter').subtract(1, 'day');
      break;
    case REQUEST_DATE.THIS_YEAR:
      dateFrom = moment().startOf('year');
      break;
    case REQUEST_DATE.LAST_YEAR:
      dateFrom = moment().startOf('year').subtract(1, 'year');
      dateTo = moment().startOf('year').subtract(1, 'day');
      break;
  }

  return { dateFrom: dateFrom.format(DATE_FORMAT), dateTo: dateTo.format(DATE_FORMAT) };
};

// this method returns years, which we can choose when creating/editing new credit card
export const initializeYears  = () => {
  let expYears = [];
  const currYear = moment().get('year');

  for (var i = 0; i < 15; i++) {
    let year = currYear + i;
    expYears.push({
      id: year,
      name: year.toString().substr(year.length - 2),
    });
  }
  return expYears;
};
